<template>
  <div class="card noborder">
    <div class="card-body pb-0">
      <h5 class="mb-0">Standalone Equipment Details</h5>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label class="custom-label">What kind of 4' Printer/s</label>
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="small-printers-stand1"
                @change="$store.commit('changeSmallPrinters', { key: 'standalone', value:'new' })"
                :checked="standalone.smallPrinters.includes('new')"
              >
              <label class="form-check-label" for="small-printers-stand1">New</label>
            </div>
            <div v-if="standalone.smallPrinters.includes('new')" class="mt-3">

              <custom-input-group
                v-for="printer in Object.keys(standalone.smallPrintersNew)"
                :key="printer"
                :prependLabel="printer"
                appendLabel="Printers"
                :value="standalone.smallPrintersNew[printer]"
                @input="$store.commit('changeSmallPrintersNew', { key:'standalone', printer, value: $event })"
              />

            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="small-printers-stand2"
                @change="$store.commit('changeSmallPrinters', { key: 'standalone', value:'refurbished' })"
                :checked="standalone.smallPrinters.includes('refurbished')"
              >
              <label class="form-check-label" for="small-printers-stand2">Refurbished</label>
            </div>
            <div v-if="standalone.smallPrinters.includes('refurbished')" class="mt-3">

              <custom-input-group
                v-for="printer in Object.keys(standalone.smallPrintersRefurbished)"
                :key="printer"
                :prependLabel="printer"
                appendLabel="Printers"
                :value="standalone.smallPrintersRefurbished[printer]"
                @input="$store.commit('changeSmallPrintersRefurbished', { key:'standalone', printer, value: $event })"
              />

            </div>
          </div>
        </div>
      </div>
      <div class="large-printers-stand">
        <div class="form-group">
          <label class="custom-label">What kind of 8' Printer/s</label>
          <div class="row">
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="large-printers-stand1"
                  @change="$store.commit('changeLargePrinters', { key: 'standalone', value:'new' })"
                  :checked="standalone.largePrinters.includes('new')"
                >
                <label class="form-check-label" for="large-printers-stand1">New</label>
              </div>
              <div v-if="standalone.largePrinters.includes('new')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(standalone.largePrintersNew)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="standalone.largePrintersNew[printer]"
                  @input="$store.commit('changeLargePrintersNew', { key:'standalone', printer, value: $event })"
                />

              </div>
            </div>
            <div class="col-sm-6 col-lg-4">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="large-printers-stand2"
                  @change="$store.commit('changeLargePrinters', { key: 'standalone', value:'refurbished' })"
                  :checked="standalone.largePrinters.includes('refurbished')"
                >
                <label class="form-check-label" for="large-printers-stand2">Refurbished</label>
              </div>
              <div v-if="standalone.largePrinters.includes('refurbished')" class="mt-3">

                <custom-input-group
                  v-for="printer in Object.keys(standalone.largePrintersRefurbished)"
                  :key="printer"
                  :prependLabel="printer"
                  appendLabel="Printers"
                  :value="standalone.largePrintersRefurbished[printer]"
                  @input="$store.commit('changeLargePrintersRefurbished', { key:'standalone', printer, value: $event })"
                />

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="custom-label">Connection with</label>
        <br>
        <custom-checkbox
          label="PC"
          value="pc"
          :checked="standalone.connections.includes('pc')"
          @input="$store.commit('changeConnection', $event)"
        />
        <custom-checkbox
          label="MAC"
          value="mac"
          :checked="standalone.connections.includes('mac')"
          @input="$store.commit('changeConnection', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['standalone'],
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/StandaloneForm.vue